export default {"src":"/pro/_next/static/media/degen.12f04692.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};